import Collapsible from "react-collapsible";
import { useState } from "react";
import useTranslate from "hooks/useTranslate";
import ArrowDown from "assets/icons/arrowDown.svg?react";
import "./styles.sass";

interface Props {
  title: string;
  description: string;
}

const FortuneWheelConditionsItem: React.FC<Props> = ({
  title,
  description,
}) => {
  const t = useTranslate();

  const [open, setOpen] = useState(false);

  const handleCollapse = () => {
    setOpen((prevState) => !prevState);
  };

  return (
    <div className="FortuneWheelConditionsItem">
      <Collapsible
        open={open}
        transitionTime={200}
        trigger={
          <div
            className="FortuneWheelConditionsItem__title"
            onClick={handleCollapse}
          >
            {t(title)}

            <ArrowDown />
          </div>
        }
      >
        {t(description)}
      </Collapsible>
    </div>
  );
};

export default FortuneWheelConditionsItem;
